module.exports = {
 //development server url
  URL: "https://gmandi.pk",
//    URL: "http://localhost:3002",
};
